import { stringify } from "qs";
import fetchClient from "api/client";
import INSIGHTS_ENDPOINT from "./insightsEndpoint";

/**
 * @description POST api/insights/export
 * */
export default function getInsightsCSV({ queryParams, filters }) {
  const queryString = stringify(
    {
      ...queryParams,
    },
    { addQueryPrefix: true },
  );

  return fetchClient.post(`${INSIGHTS_ENDPOINT}/export${queryString}`, {
    body: filters,
  });
}
